import React from 'react';
import classnames from 'classnames';
import { useBreakpoints } from '@fiverr-private/hooks';
import { HourlyRate } from '@fiverr-private/seller_pages_toolbox';
import { Stack } from '@fiverr-private/layout_components';
import { SOURCES } from '../../../monitoring';
import { ContactButton } from '../../common/ActionButtons';
import { RespondTimeInfo } from '../../common/Info';
import { isBrowser } from '../../../utils';
import { useRolloutContext } from '../../../contexts/RolloutContext';
import styles from './index.module.scss';

const stickyFooterClasses = 'p-16 flex flex-items-center flex-end box-shadow-z2 flex-center flex-col-reverse';

/** @type {React.ComponentProps<typeof Stack>} */
const hourlyRateContainerProps = {
    direction: 'row',
    justifyContent: 'spaceBetween',
    alignItems: 'center',
    wrap: 'nowrap',
    gap: '6',
};

/** @type {React.ComponentProps<typeof Stack>} */
const defaultContainerProps = {
    wrap: 'wrap',
};

/** @type {React.FC<{className?: string; username: string; respondHours: number; hourlyRateInUsdCents?: number}>} */
export const StickyFooter = ({ className, username, respondHours, hourlyRateInUsdCents }) => {
    const { md: isMD } = useBreakpoints();
    const { inZebrasHourlyRateRollout } = useRolloutContext();
    const shouldShowHourlyRate = inZebrasHourlyRateRollout && hourlyRateInUsdCents;

    if (isMD || !isBrowser()) {
        return null;
    }

    const containerProps = shouldShowHourlyRate ? hourlyRateContainerProps : defaultContainerProps;

    return (
        <Stack className={classnames(className, styles.stickyFooter, stickyFooterClasses)} {...containerProps}>
            <Stack direction="column" gap="0">
                {shouldShowHourlyRate && <HourlyRate hourlyRateInUsdCents={hourlyRateInUsdCents} fontSize="b_md" />}
                <RespondTimeInfo respondHours={respondHours} />
            </Stack>
            <ContactButton
                className={styles.contactBtn}
                username={username}
                source={SOURCES.page}
                renderDropdown={true}
            />
        </Stack>
    );
};
